export const ERROR_BOUNDARY_STRINGS = {
  title: 'What planet are we on?',
  description: 'Looks like there is an error!',
  button: 'Try again?',
};
